import { type Enum } from '@webapp/infrastructure/types/Enum'

export const GlobalSearchResultStatuses = {
  PENDING_APPROVAL: 'pending-approval',
  APPROVED: 'approved',
  DENIED: 'denied',
  PURCHASED: 'purchased',
  RECEIVED: 'received',
  OPEN: 'open',
  REOPENED: 'reopened',
  CANCELLED: 'cancelled',
  CLOSED: 'closed',
  PAID: 'paid',
  DRAFT: 'draft',
  SCHEDULED: 'scheduled',
  PROCESSING: 'processing',
  FAILED: 'failed',
} as const

export type GlobalSearchResultStatusEnum = Enum<
  typeof GlobalSearchResultStatuses
>
